<template>
	<div
		class="gop-notification-container"
		aria-live="polite"
		aria-relevant="additions removals"
	>
		<transition-group
			name="notification"
			tag="div"
			class="notification-list"
		>
			<div
				v-for="notification in notifications"
				:key="notification.id"
				class="notification"
				:class="`notification--${notification.type}`"
				role="status"
				@mouseenter="pause(notification.id)"
				@mouseleave="resume(notification.id)"
			>
				<div class="notification__content">
					<div class="notification__icon" aria-hidden="true">
						<svg
							v-if="notification.type === 'success'"
							viewBox="0 0 24 24"
						>
							<path
								d="M20 6L9 17l-5-5"
								fill="none"
								stroke="currentColor"
								stroke-width="2.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>

						<svg
							v-else-if="notification.type === 'error'"
							viewBox="0 0 24 24"
						>
							<path
								d="M7 7l10 10M17 7L7 17"
								fill="none"
								stroke="currentColor"
								stroke-width="2.5"
								stroke-linecap="round"
							/>
						</svg>

						<svg
							v-else-if="notification.type === 'warning'"
							viewBox="0 0 24 24"
						>
							<path
								d="M12 8v5M12 17h.01"
								fill="none"
								stroke="currentColor"
								stroke-width="2.5"
								stroke-linecap="round"
							/>
						</svg>

						<svg v-else viewBox="0 0 24 24">
							<path
								d="M12 11v6M12 7h.01"
								fill="none"
								stroke="currentColor"
								stroke-width="2.5"
								stroke-linecap="round"
							/>
						</svg>
					</div>

					<div class="notification__message">
<!--						{{ notification.message }}-->
						{{ $t(notification.message) ? $t(notification.message) : notification.message}}
					</div>

					<button
						type="button"
						class="notification__close"
						aria-label="Close notification"
						@click="close(notification.id)"
					>
						<svg viewBox="0 0 24 24" aria-hidden="true">
							<path
								d="M6 6l12 12M18 6L6 18"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
							/>
						</svg>
					</button>
				</div>

<!--				<div-->
<!--					v-if="notification.duration > 0"-->
<!--					class="notification__timer"-->
<!--					aria-hidden="true"-->
<!--				>-->
<!--					<div-->
<!--						class="notification__timer-progress"-->
<!--						:style="{ width: `${notification.progress}%` }"-->
<!--					/>-->
<!--				</div>-->
				<div
					v-if="notification.duration > 0"
					class="notification__lifetime"
					:style="{ height: `${notification.progress}%` }"
					aria-hidden="true"
				/>
			</div>
		</transition-group>
	</div>
</template>

<script>
import {
	notificationState,
	notifyGop
} from '@/gop-redesign/services/gopNotifications';

export default {
	name: 'GopNotification',
	computed: {
		notifications() {
			return notificationState.notifications;
		}
	},
	methods: {
		close(id) {
			notifyGop.close(id);
		},

		pause(id) {
			notifyGop.pause(id);
		},

		resume(id) {
			notifyGop.resume(id);
		}
	},

	beforeDestroy() {
		notifyGop.clear();
	}
};
</script>

<style scoped lang="scss">
$success-color: #28a873;
$error-color: #d84a4a;
$warning-color: #e2a12c;
$info-color: #3788d8;
$text-color: #435466;
$background-color: #ffffff;

.gop-notification-container {
	position: fixed;
	top: 80px;
	right: 25px;
	z-index: 9999;
	width: min(380px, calc(100vw - 32px));
	pointer-events: none;
}

.notification-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.notification {
	position: relative;
	overflow: hidden;
	background: $background-color;
	border-left: 0px solid $success-color;
	box-shadow:
		0 4px 14px rgba(15, 42, 61, 0.18),
		0 1px 3px rgba(15, 42, 61, 0.12);
	pointer-events: auto;

	&__content {
		display: flex;
		align-items: center;
		min-height: 54px;
		padding: 8px 10px;
	}

	&__icon {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 21px;
		width: 21px;
		height: 21px;
		margin: 0 11px 0 1px;
		color: #ffffff;
		background: $success-color;
		border-radius: 50%;

		svg {
			width: 16px;
			height: 16px;
		}
	}

	&__message {
		flex: 1;
		color: $text-color;
		font-size: 14px;
		font-weight: 600;
		line-height: 1.4;
		word-break: break-word;
	}

	&__close {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 34px;
		width: 34px;
		height: 34px;
		margin-left: 10px;
		padding: 0;
		color: #647586;
		background: transparent;
		border: 0;
		border-radius: 4px;
		cursor: pointer;
		transition:
			color 160ms ease,
			background-color 160ms ease;

		svg {
			width: 21px;
			height: 21px;
		}

		&:hover {
			color: #263746;
			background: #f1f4f6;
		}

		&:focus-visible {
			outline: 2px solid currentColor;
			outline-offset: 1px;
		}
	}

	&__lifetime {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 4px;
		height: 100%;
		background: $success-color;
		will-change: height;
	}

	//&__timer {
	//	position: absolute;
	//	right: 0;
	//	bottom: 0;
	//	left: 0;
	//	height: 3px;
	//	background: rgba(0, 0, 0, 0.06);
	//}
	//
	//&__timer-progress {
	//	width: 100%;
	//	height: 100%;
	//	background: $success-color;
	//	will-change: width;
	//}

	&--error {
		border-left-color: $error-color;

		.notification__icon,
		//.notification__timer-progress {
		.notification__lifetime {
			background: $error-color;
		}
	}

	&--warning {
		border-left-color: $warning-color;

		.notification__icon,
		.notification__lifetime {
		//.notification__timer-progress {
			background: $warning-color;
		}
	}

	&--info {
		border-left-color: $info-color;

		.notification__icon,
		.notification__lifetime {
		//.notification__timer-progress {
			background: $info-color;
		}
	}
}


.notification-enter-active {
	animation: notification-in 0.3s ease-out;
}

.notification-leave-active {
	transition:
		opacity 0.28s ease,
		transform 0.28s ease;
}

.notification-enter,
.notification-leave-to {
	opacity: 0;
}

.notification-leave-to {
	transform: translateX(35px);
}

.notification-move {
	transition: transform 0.3s ease;
}

@keyframes notification-in {
	0% {
		opacity: 0;
		transform: translateX(40px) scale(0.95);
	}
	70% {
		opacity: 1;
		transform: translateX(-3px) scale(1);
	}
	100% {
		opacity: 1;
		transform: translateX(0) scale(1);
	}
}

//.notification-enter-active,
//.notification-leave-active,
//.notification-move {
//	transition:
//		opacity 280ms ease,
//		transform 280ms ease;
//}
//
//.notification-enter {
//	opacity: 0;
//	transform: translateX(35px);
//}
//
//.notification-leave-to {
//	opacity: 0;
//	transform: translateX(35px);
//}
//
//.notification-leave-active {
//	position: absolute;
//	width: 100%;
//}

@media (max-width: 600px) {
	.gop-notification-container {
		top: 10px;
		right: 10px;
		width: calc(100vw - 20px);
	}
}

@media (prefers-reduced-motion: reduce) {
	.notification-enter-active,
	.notification-leave-active,
	.notification-move {
		transition-duration: 1ms;
	}
}
</style>
